
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bdn6P", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.388191ea.js.map
